import { getTitle } from './listingHelper';
import messages from './translationMessages';
import { formatMessage as t } from './language';
import { getBoatUrl } from './urlHelpers/boat';
import get from 'lodash/get';
import { getAssetUrl } from './commonHelper';

export const more = (listing) => {
  window.navigator.share({
    title: getSocialTitle(listing),
    url: getBoatUrl(listing),
  });
};

export const getSocialTitle = (listing, domain) => {
  if (listing.id) {
    const condition = t(messages[listing.condition]);
    return t(
      messages.socialTitle,
      {
        condition: condition.toLowerCase(),
        title: getTitle(listing),
        domain: domain
      }
    );
  }
  return '';
};

export const email = (url, title) => {
  url = `mailto:?subject=${title}&body=${encodeURIComponent(url)}`;
  let win = window.open(url, '_blank');
  win.focus();
};

export const print = () => {
  window.print();
};

export const openSocialModal = (id, url, title, listing) => {
  const width = 650;
  const height = 450;
  const medias = get(listing,'media',[]);
  let mediaImage = getAssetUrl('/assets/images/default/boat-image.jpg');
  for (let media of medias) {
    if (media.mediaType === 'image') {
      mediaImage = media.url;
      break;
    }
  }

  const links = {
    'facebook': {
      'href': `https://www.facebook.com/sharer/sharer.php?u=${escape(url)}`
    },
    'twitter': {
      'href': `https://twitter.com/intent/tweet?url=${escape(url)}&text=${title}`
    },
    'whatsapp': {
      'href': `https://wa.me/?text=${encodeURIComponent(`Check out this ${title}`)} ${escape(url)}`
    },
    'pinterest': {
      'href': `https://pinterest.com/pin/create/link/?url=${url}&media=${mediaImage}`
    }
  };

  const { href } = links[id];

  /* eslint-disable max-len */
  window.open(href, '_blank', `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${width},height=${height},top=${(window.screen.height / 2 - height / 2)},left=${(window.screen.width / 2 - width / 2)}`);
};
